import { AppState } from '../../app-state';

export const selectAnnotationPanePageOffsets = (state: AppState) =>
  state._UI_panes.annotationPanePageOffsets;

export const selectPdfPaneWidth = (state: AppState) =>
  state._UI_panes.pane_0.size;
